import React from "react"
import StyledSection from "./styles/StyledSection"
import Heading from "./Heading"

const Interests = () => {
  return (
    <StyledSection id="interests">
      <Heading title="Interests" />
      <p>
        Apart from being a web developer, I enjoy most of my time being
        outdoors. In the winter, I am an avid skier and novice ice climber.
        During the warmer months here in Colorado, I enjoy mountain biking, free
        climbing, and kayaking.
      </p>
      <p>
        When forced indoors, I follow a number of sci-fi and fantasy genre
        movies and television shows, I am an aspiring chef, and I spend a large
        amount of my free time exploring the latest technology advancements in
        the front-end web development world.
      </p>
    </StyledSection>
  )
}

export default Interests
